import { create } from 'zustand';
import type { ReactNode } from 'react';

interface UIState {
  // Modals
  isAuthModalOpen: boolean;
  isForgotPasswordModalOpen: boolean;
  isProjectModalOpen: boolean;
  isTaskModalOpen: boolean;
  isVersionModalOpen: boolean;
  isTemplateModalOpen: boolean;
  isTemplateShopModalOpen: boolean;
  isFullscreenChartOpen: boolean;
  isSaveModalOpen: boolean;
  isProjectListModalOpen: boolean;
  
  // UI State
  isSidebarOpen: boolean;
  isLoading: boolean;
  toast: { message: ReactNode; type: 'success' | 'error' | 'info' | 'warning' } | null;
  
  // Actions
  openAuthModal: () => void;
  closeAuthModal: () => void;
  openForgotPasswordModal: () => void;
  closeForgotPasswordModal: () => void;
  openProjectModal: () => void;
  closeProjectModal: () => void;
  openTaskModal: () => void;
  closeTaskModal: () => void;
  openVersionModal: () => void;
  closeVersionModal: () => void;
  openTemplateModal: () => void;
  closeTemplateModal: () => void;
  openTemplateShopModal: () => void;
  closeTemplateShopModal: () => void;
  openFullscreenChart: () => void;
  closeFullscreenChart: () => void;
  openSaveModal: () => void;
  closeSaveModal: () => void;
  openProjectListModal: () => void;
  closeProjectListModal: () => void;
  toggleSidebar: () => void;
  showToast: (message: ReactNode, type: 'success' | 'error' | 'info' | 'warning') => void;
  hideToast: () => void;
  setLoading: (isLoading: boolean) => void;
}

export const useUIStore = create<UIState>()((set) => ({
  isAuthModalOpen: true,
  isForgotPasswordModalOpen: false,
  isProjectModalOpen: false,
  isTaskModalOpen: false,
  isVersionModalOpen: false,
  isTemplateModalOpen: false,
  isTemplateShopModalOpen: false,
  isFullscreenChartOpen: false,
  isSaveModalOpen: false,
  isProjectListModalOpen: false,
  isSidebarOpen: true,
  isLoading: false,
  toast: null,

  openAuthModal: () => set({ isAuthModalOpen: true }),
  closeAuthModal: () => set({ isAuthModalOpen: false }),
  
  openForgotPasswordModal: () => set({ isForgotPasswordModalOpen: true }),
  closeForgotPasswordModal: () => set({ isForgotPasswordModalOpen: false }),

  openProjectModal: () => set({ isProjectModalOpen: true }),
  closeProjectModal: () => set({ isProjectModalOpen: false }),
  
  openTaskModal: () => set({ isTaskModalOpen: true }),
  closeTaskModal: () => set({ isTaskModalOpen: false }),
  
  openVersionModal: () => set({ isVersionModalOpen: true }),
  closeVersionModal: () => set({ isVersionModalOpen: false }),
  
  openTemplateModal: () => set({ isTemplateModalOpen: true }),
  closeTemplateModal: () => set({ isTemplateModalOpen: false }),
  
  openTemplateShopModal: () => set({ isTemplateShopModalOpen: true }),
  closeTemplateShopModal: () => set({ isTemplateShopModalOpen: false }),
  
  openFullscreenChart: () => set({ isFullscreenChartOpen: true }),
  closeFullscreenChart: () => set({ isFullscreenChartOpen: false }),
  
  openSaveModal: () => set({ isSaveModalOpen: true }),
  closeSaveModal: () => set({ isSaveModalOpen: false }),
  
  openProjectListModal: () => set({ isProjectListModalOpen: true }),
  closeProjectListModal: () => set({ isProjectListModalOpen: false }),
  
  toggleSidebar: () => set((state) => ({ isSidebarOpen: !state.isSidebarOpen })),
  
  showToast: (message, type) => set({ toast: { message, type } }),
  hideToast: () => set({ toast: null }),
  
  setLoading: (isLoading) => set({ isLoading }),
}));
